import { apiUrl, deleteJson, getJson, postJson, uploadForm } from './client'
import type { DocumentOrigin, DocumentQuery, DocumentSummary, DocumentTargets, DocumentUploaded, DocumentView } from '../types/documents'

// Documents (REQ-119, REQ-120): stored once, read at upload, facts drawn by a job. An upload names what it is
// attached to (a person, an engagement, a company — at least one) and where it was offered from. The file itself
// is loaded by the browser as a download, not fetched. The only place fetch lives is client.ts.
const root = (spoke: string) => `/api/spokes/${encodeURIComponent(spoke)}/scout/documents`
const one = (spoke: string, documentId: string) => `${root(spoke)}/${encodeURIComponent(documentId)}`

export const documentsApi = {
  /** Multipart upload (202): the document and the job reading it. A refusal says why: the kind, the size, an unknown target. */
  upload: (spoke: string, file: File, targets: DocumentTargets & { origin: DocumentOrigin }, onProgress?: (fraction: number) => void) => {
    const form = new FormData()
    form.append('file', file, file.name)
    form.append('origin', targets.origin)
    if (targets.personId) form.append('personId', targets.personId)
    if (targets.engagementId) form.append('engagementId', targets.engagementId)
    if (targets.companyId) form.append('companyId', targets.companyId)
    return uploadForm<DocumentUploaded>(root(spoke), form, onProgress)
  },
  /** The documents on a person, an engagement or a company, newest first. */
  list: (spoke: string, query: DocumentQuery) => getJson<DocumentSummary[]>(root(spoke), { person: query.person, engagement: query.engagement, company: query.company }),
  get: (spoke: string, documentId: string) => getJson<DocumentView>(one(spoke, documentId)),
  /** The file as the browser should load it (a download; the uploader or an admin). */
  fileUrl: (spoke: string, documentId: string) => apiUrl(`${one(spoke, documentId)}/file`),
  /** Reads it again (202): a new job. */
  reread: (spoke: string, documentId: string) => postJson<{ jobId: string }>(`${one(spoke, documentId)}/read`),
  /** The uploader withdraws it (204). */
  withdraw: (spoke: string, documentId: string) => deleteJson<void>(one(spoke, documentId)),
}
